import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { work } from '../data/work';
import type { WorkItem } from '../types/work';
const ease = [0.23, 1, 0.32, 1] as const;
const rowClassName = 'group flex flex-col gap-4 py-8 sm:flex-row sm:items-start sm:gap-10';
function RowContent({
  item
}: {
  item: WorkItem;
}) {
  const hasDetail = Boolean(item.detail);
  return <>
      <div className="min-w-0 flex-1" data-id="element-83" data-mp="3vyqj9ozhcr3w">
        <h2 className="flex items-center gap-1.5 text-2xl font-medium tracking-tight text-ink transition-opacity duration-150 ease-expo group-hover:opacity-60 md:text-3xl" data-id="element-84" data-mp="3vxp8llmdm6mp">
          {item.title}
          {hasDetail ? <ArrowRightIcon className="h-5 w-5 text-ink-faint transition-transform duration-200 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-85" data-mp="3n3smg6t7ou7a" /> : item.href && <ArrowUpRightIcon className="h-5 w-5 text-ink-faint transition-transform duration-200 ease-expo group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-86" data-mp="3i93ma9k3crlg" />}
        </h2>
        <p className="mt-2 max-w-2xl text-[16px] leading-relaxed text-ink-muted" data-id="element-87" data-mp="3s19974vhkits">
          {item.summary}
        </p>
      </div>
      <div className="shrink-0 text-[13px] text-ink-faint sm:text-right" data-id="element-88" data-mp="5rotaah513uq">
        <p className="text-ink-muted" data-id="element-89" data-mp="t3u8edmgq7v">{item.role}</p>
        <p className="mt-1" data-id="element-90" data-mp="sc1dbbet6la">{item.year}</p>
      </div>
    </>;
}
export function Work() {
  return <main className="mx-auto w-full max-w-[86rem] px-6 py-10 md:px-10" data-id="element-91" data-mp="esczij0ahzx2">
      <Link to="/" className="group inline-flex items-center gap-2 text-[13px] text-ink-muted transition-colors duration-150 ease-expo hover:text-ink" data-id="element-92" data-mp="9tjwxlmjjtbo">
        <ArrowLeftIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-expo group-hover:-translate-x-0.5" aria-hidden="true" data-id="element-93" data-mp="2bleu6w81vvad" />
        Home
      </Link>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease
    }} className="mt-20 md:mt-28" data-id="element-94" data-mp="kgv3ri80o2pu">
        <h1 className="text-4xl font-medium leading-[1.04] tracking-tightest text-ink sm:text-5xl md:text-[64px]" data-id="element-95" data-mp="pikfz16z6mfi">
          My Work
        </h1>
        <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-ink-muted" data-id="element-96" data-mp="yfutyub6gpo4">
          A running list of things I&rsquo;ve designed, built, or written about.
        </p>
      </motion.div>

      {work.length === 0 ? <p className="mt-16 text-[15px] text-ink-muted" data-id="element-97" data-mp="1877hxatuuvov">Nothing here yet.</p> : <ul className="mt-16 border-t border-rule" data-id="element-98" data-mp="1d4h9ox4pvjfv">
          {work.map(item => <li key={item.slug} className="border-b border-rule" data-id="element-99" data-mp="1h8f5oyyqwe4p">
              {item.detail ? <Link to={`/work/${item.slug}`} className={rowClassName} data-id="element-100" data-mp="1m7i9kg2zoeb3">
                  <RowContent item={item} data-id="element-101" data-mp="36p0zv5m9ukq7" />
                </Link> : item.href ? <a href={item.href} target="_blank" rel="noreferrer" className={rowClassName} data-id="element-102" data-mp="31owti8f2v6dp">
                  <RowContent item={item} data-id="element-103" data-mp="2soq9s4ssda63" />
                </a> : <div className={rowClassName} data-id="element-104" data-mp="2sr2wswdeiaq0">
                  <RowContent item={item} data-id="element-105" data-mp="3pdxsl520t56b" />
                </div>}
            </li>)}
        </ul>}
    </main>;
}